import React from "react";
import { NavLink, NavLinkProps } from "react-router-dom";

const ForwardNavLink = React.forwardRef<HTMLAnchorElement, NavLinkProps>(
  (props, ref) => <NavLink {...props} ref={ref} />
);

ForwardNavLink.displayName = "NavLink";

export default ForwardNavLink;
